// 📄 src/capabilities/workspacePerms.js

import { FK } from "./featureKeys";

/**
 * WORKSPACE_PERMS
 * - Used by sidebar + /app/{workspace} routes
 * - Each workspace should normally have ONE main key: *.WORKSPACE.VIEW
 */
export const WORKSPACE_PERMS = {
  messaging: [FK.MESSAGING_WORKSPACE_VIEW],
  superadmin: [FK.SUPER_ADMIN_WORKSPACE_VIEW],
  campaigns: [FK.CAMPAIGN_WORKSPACE_VIEW],
  automation: [FK.AUTOMATION_WORKSPACE_VIEW, FK.AUTOMATION_SCHEDULED_MESSAGES_VIEW],
  aiAgent: [FK.AI_AGENT_WORKSPACE_VIEW],
  templates: [FK.TEMPLATE_WORKSPACE_VIEW],
  catalog: [FK.CATALOG_WORKSPACE_VIEW],
  crm: [FK.CRM_WORKSPACE_VIEW],
  inbox: [FK.INBOX_WORKSPACE_VIEW],
  settings: [FK.SETTINGS_WORKSPACE_VIEW],
};

export const TEMPLATE_BUILDER_ACCESS_PERMS = [
  FK.TEMPLATE_WORKSPACE_VIEW,
  FK.TEMPLATE_BUILDER_LIBRARY_BROWSE,
  FK.TEMPLATE_BUILDER_CREATE_DRAFT,
  FK.TEMPLATE_BUILDER_DRAFT_EDITOR_VIEW,
  FK.TEMPLATE_BUILDER_PENDING_TEMPLATES_VIEW,
  FK.TEMPLATE_BUILDER_APPROVED_TEMPLATES_VIEW,
];
